import {Component, Prop, Vue} from "vue-property-decorator";
import {UserModule} from "@/store/modules/user";
import {Loading} from "element-ui";
import {addMessageReviewUserByMessageReviewId} from "@/api/message";
import {delNullProperty} from "@/utils";
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";

@Component({
    components:{
        MoreUsersFilter
    }
})
export default class AddSign extends Vue {
    @Prop() visible: false
    @Prop() id: ''
    disBtn = false
    userId = '' // 加签人Id
    opinion = '' // 加签理由


    created() {
        // console.log('this.id', this.id)
    }

    // computed


    /*
    * methods*/
    changeUsers(e) {
        this.userId = e.id
    }

    closeAddSignDialog() {
        this.$emit('handleClose', false)
    }

    confirmAddSignDialog() {
        if (!this.userId) {
            this.$message.error('请选择加签人')
            return
        }
        this.disBtn = true;
        this.$emit('doConfirm', false)
        const obj = {
            messageReviewId: Number(this.id),
            opinion: this.opinion,
            userId: this.userId,
        }
        const loading = this.$loading({
            lock: true,
            text: '审批加签中，请稍后',
            spinner: 'el-icon-loading',
            background: 'rgba(255, 255, 255, 0.7)'
        });
        addMessageReviewUserByMessageReviewId(delNullProperty(obj)).then(() => {
            this.opinion = ''
            this.userId = ''
            this.$message.success('审批加签成功')
            setTimeout(() => {
                loading.close();
                window.close()
            }, 1500)
        }).catch((err: Error) => {
            console.log(err)
            this.disBtn = false;
            setTimeout(() => {
                loading.close();
            }, 500);
        })
    }

}
